export default "__VITE_ASSET__DHQ0fN6u__"